import { functionsUrl } from "@/plugins/firebase";
import axios from "axios";
import { ref } from "vue";

export const comments = ref<any[]>([]);

export const getComments = async () => {
  const response = await axios.get(`${functionsUrl}getComments`);

  //console.log(`${functionsUrl}getComments`, response.data);

  comments.value = response.data;
};
